module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "com-model company-base flex align-initial m-b-15 relative"
  }, [_c('div', {
    staticClass: "cy-logo",
    on: {
      "mouseover": _vm.overShow,
      "mouseout": _vm.outHide
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.companyInfo.logo,
      "alt": "logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-btn"
  }, [_vm._v("更改LOGO")]), _vm._v(" "), _c('input', {
    staticClass: "ch-inp",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.logoChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column flex-between align-start"
  }, [_c('div', {
    staticClass: "cy-title "
  }, [_vm._v(_vm._s(_vm.companyInfo.shortName))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex long-name"
  }, [_c('img', {
    staticStyle: {
      "width": "24px",
      "height": "24px",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../../assets/images/company/title_icon.png")
    }
  }), _vm._v("\r\n                    " + _vm._s(_vm.companyInfo.name) + "\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "flex detail"
  }, [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-right": "24px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../../assets/images/company/hangye_icon.png")
    }
  }), _vm._v("\r\n                        " + _vm._s(_vm.companyInfo.industryName) + "\r\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-right": "24px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../../assets/images/company/user_icon.png")
    }
  }), _vm._v("\r\n                        " + _vm._s(_vm.companyInfo.scale) + "\r\n                    ")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "primary-btn right-btn",
    attrs: {
      "to": {
        path: '/index/company/base'
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-model m-b-15 relative company-location"
  }, [_c('div', {
    staticClass: "com-title m-b-20"
  }, [_vm._v("公司位置")]), _vm._v(" "), _c('div', {
    staticClass: "flex align-start warp"
  }, [_c('div', [_c('div', {
    staticClass: "flex company-in-title"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/images/company/position_icon.png")
    }
  }), _vm._v("\r\n                    " + _vm._s(_vm.companyInfo.cityName) + " " + _vm._s(_vm.companyInfo.areaName) + "\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "company-in-detail"
  }, [_vm._v("\r\n                     " + _vm._s(_vm.companyInfo.provinceName) + " " + _vm._s(_vm.companyInfo.cityName) + " " + _vm._s(_vm.companyInfo.areaName) + " " + _vm._s(_vm.companyInfo.address) + "\r\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "map",
    attrs: {
      "id": "container"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "primary-btn right-btn",
    attrs: {
      "to": {
        path: '/index/company/base',
        query: {
          type: 'location'
        }
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-model company-license relative"
  }, [_c('div', {
    staticClass: "com-title ",
    class: {
      'm-b-20': !!this.companyInfo.license
    }
  }, [_vm._v("工商信息")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [(this.companyInfo.licenseImg) ? _c('div', {
    staticClass: "renzheng-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.companyInfo.licenseImg,
      "alt": "license"
    }
  }), _vm._v(" "), (this.companyInfo.isAuth == 1) ? _c('div', {
    staticClass: "license-auth flex flex-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/company/auth_icon.png")
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "company-in-detail"
  }, [_vm._v("\r\n                     " + _vm._s(_vm.companyInfo.name) + "\r\n                ")]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "company-in-detail"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.companyInfo.license) + "\r\n                ")])])]), _vm._v(" "), (this.companyInfo.isAuth != 1) ? _c('div', {
    staticClass: "right-btn flex"
  }, [(this.companyInfo.license) ? _c('span', {
    staticStyle: {
      "color": "#FF7A45",
      "font-size": "20px",
      "margin-right": "20px"
    }
  }, [_vm._v(" " + _vm._s(this.companyInfo.authStatus == 0 ? '待审核' : this.companyInfo.authStatus == -1 ? '审核未通过' : '已认证') + " ")]) : _vm._e(), _vm._v(" "), (!this.companyInfo.license || this.companyInfo.authStatus == -1) ? _c('router-link', {
    staticClass: "primary-btn ",
    attrs: {
      "to": {
        path: '/index/company/auth'
      }
    }
  }, [_vm._v(_vm._s(!this.companyInfo.license ? '去认证' : '重新提交'))]) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex company-in-title"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/images/company/title_icon.png")
    }
  }), _vm._v("\r\n                    企业名称\r\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex company-in-title"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/images/company/daima_icon.png")
    }
  }), _vm._v("\r\n                    信用代码\r\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4de43bfd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/finance/company.vue
// module id = 876
// module chunks = 1